import { render } from "./AllReturnsBills.vue?vue&type=template&id=2a4c3fb6&scoped=true"
import script from "./AllReturnsBills.vue?vue&type=script&lang=js"
export * from "./AllReturnsBills.vue?vue&type=script&lang=js"

import "./AllReturnsBills.vue?vue&type=style&index=0&id=2a4c3fb6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4c3fb6"]])

export default __exports__